import React, { useEffect, useState } from 'react'
import useRenewalFlow from '../../../../hooks/useRenewalFlow'
import RenewMotorLayout from '../renewMotorLayout';
import { useTranslation } from 'react-i18next';
import TitleDescription from '../../../../components/newMotorPolicy/titleDescription/titleDescription';
import VerifyOtpComponent from './verifyOtpComponent';
import { useDispatch } from "react-redux";
import { selectNewMotorForm } from "../../../../redux/features/newMotorFormSlice";
import { useSelector } from "react-redux";
import { RENEW_POLICY_CPR_PLATE_NUMBER } from "../cprNumberPage/cprPlateNumberPage"
import { sendLoginOtp, verifyLoginOtp, selectLoginOtpPinId } from "../../../../redux/features/account/accountOtpSlice";
import { unwrapResult } from "@reduxjs/toolkit";
import { fetchUserPolicies } from '../../../../redux/features/myPolicySlice';
import { toast } from 'sonner';
import { getClientSource } from "../../../../utils/getClientSource";
import { setLoginTokenInfo } from "../../../../redux/features/loginRegisterSlice";
import { motorRenewalPremium } from "../../../../redux/features/motor/renewalPremiumSlice";
import { clearApplyPromoState } from "../../../../redux/features/promoCode/promoCodeSlice";
import useLanguageTranslate from "../../../../hooks/useLanguageTranslate";
import { PROMO_CODE } from "../../../../components/newMotorPolicy/veiwSummaryPopup/viewSummaryPopup";
import useMotorForm from "../../../../hooks/useMotorFormData";

const VerifyOtpPage = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const translate = useLanguageTranslate();
  
  const otpInfo = useSelector(selectNewMotorForm)?.[RENEW_POLICY_CPR_PLATE_NUMBER];
  const reduxPinId = useSelector(selectLoginOtpPinId);
  const [otpPinId, setOtpPinId] = useState(otpInfo?.pinId || reduxPinId || ""); 
  const [otp, setOtp] = useState();
  const [isLoading, setIsLoading] = useState(false);

  const { handleNextSubstep } = useRenewalFlow();

  const [, setFormData] = useState({});
  const { removeMotorFormPromoCodeData } = useMotorForm(PROMO_CODE, setFormData);

  // Resending OTP
  const notRecivedCodeHandler = async () => {
    try {
      const sendOtpPayload = {
        CPR: otpInfo?.cprNumber,
      };
      const sendOtpAction = await dispatch(sendLoginOtp(sendOtpPayload));
      const sendOtpResult = unwrapResult(sendOtpAction);

      if (sendOtpResult) {
        toast.success(translate("OTP resent successfully", "تم إعادة إرسال رمز التحقق بنجاح"));
        setOtpPinId(sendOtpResult.pinId);
      }
    } catch (error) {
      const errorMessage = error?.ErrorMessageEn || "Failed to resend OTP";
      toast.error(translate(errorMessage, error?.ErrorMessageAr || errorMessage));
    }
  };

  useEffect(() => {
    const pinId = otpInfo?.pinId || reduxPinId;
    if (pinId) {
      setOtpPinId(pinId);
    }
  }, [otpInfo, reduxPinId]);

  const continueClickHanlder = async () => {
    setIsLoading(true);
    try {
      const verifyPayload = {
        CPR: otpInfo?.cprNumber,
        pinId: otpPinId,
        pin: otp,
      };

      const verifyAction = await dispatch(verifyLoginOtp(verifyPayload));
      const verifyResult = unwrapResult(verifyAction);

      if (verifyResult) {
        dispatch(setLoginTokenInfo(verifyResult));

        const getPoliciesPayload = {
          Cpr: otpInfo?.cprNumber,
          Channel: getClientSource(),
          token: verifyResult.access_token,
        };

        const fetchPolicyAction = await dispatch(fetchUserPolicies(getPoliciesPayload));
        const fetchPolicyResult = unwrapResult(fetchPolicyAction);

        if (fetchPolicyResult) {
          const matchingPolicy = fetchPolicyResult.find(
            (policy) =>
              policy.RegistrationNumber == otpInfo?.plateNumber &&
              policy.IsRenewable == true &&
              policy.Renewed !== "Yes"
          );

          if (matchingPolicy) {
            await removeMotorFormPromoCodeData();
            await dispatch(clearApplyPromoState());

            const premiumPayload = {
              PolicyNumber: matchingPolicy.PolicyNumber,
              Channel: getClientSource(),
            };

            const premiumAction = await dispatch(motorRenewalPremium(premiumPayload));
            const premiumResult = unwrapResult(premiumAction);

            if (premiumResult) {
              handleNextSubstep();
            }
          } else {
            const policyWithPlate = fetchPolicyResult.find(
              (policy) => policy.RegistrationNumber == otpInfo?.plateNumber
            );

            if (policyWithPlate) {
              toast.error(
                translate(
                  `The Registration number ${otpInfo?.plateNumber} is not due for renewal yet.`,
                  `رقم التسجيل ${otpInfo?.plateNumber} غير مستحق للتجديد بعد.`
                )
              );
            } else {
              toast.error(
                translate(
                  `No policy found with Registration Number ${otpInfo?.plateNumber}.`,
                  `لم يتم العثور على بوليصة برقم اللوحة ${otpInfo?.plateNumber}.`
                )
              );
            }
          }
        }
      }
    } catch (error) {
      const errorMessage = error?.ErrorMessageEn || "Failed to verify OTP";
      toast.error(translate(errorMessage, error?.ErrorMessageAr || errorMessage));
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <RenewMotorLayout
      btn_disabled={!(otp?.length == 4) || isLoading}
      btn_onClick={continueClickHanlder}
    >
      <div className='reniewlotp p-5'>
        <TitleDescription
          title={t("motorInsurance.renewalPolicyFlow.verifyOtpPage.title")}
          description={t(
            "motorInsurance.renewalPolicyFlow.verifyOtpPage.description"
          )}
        />
        <VerifyOtpComponent
          notRecivedCodeHandler={notRecivedCodeHandler}
          otp={otp}
          setOtp={setOtp}
          mobile= {otpInfo ? otpInfo.phone : ""}
          navigationPath={"/sign-up"}
        />

      </div>
    </RenewMotorLayout>
  );
}

export default VerifyOtpPage